import { FC } from "react";
import { BrokerOnboardingRequestDto } from "../../../api/Api";
import { MyOnboardingRequestsGrid } from "../../../components/onboardingRequests/myRequestsGrid";
import { OnboardingRequestBook } from "../../../components/onboardingRequests/types";
import { useMyBrokerOnboardingRequests } from "../../admin/brokerOnboardingRequests/queries";

const brokerBook: OnboardingRequestBook<BrokerOnboardingRequestDto> = {
  entityLabel: "Broker",
  entityName: (row) => row.payload?.brokerName ?? "",
  resultingEntityId: (row) => row.resultingBrokerId,
  entityPath: (id) => `/brokers/broker/${id}`
};

export const MyBrokerRequests: FC = () => (
  <MyOnboardingRequestsGrid
    book={brokerBook}
    useMyRequests={useMyBrokerOnboardingRequests}
  />
);
